// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CONFIRM = "Potvr\u010f";
export const FORUM_ADD_QUESTION_IN_COUNSELLING = "Polo\u017e ot\u00e1zku v poradni";
export const SEO_DESCRIPTION_FORUM_POST_perex = "%(perex)s - Aj o tom sa diskutuje na Modrom kon\u00edku. Pre\u010d\u00edtaj si sk\u00fasenosti a n\u00e1zory ostatn\u00fdch. ";
export const SEO_TITLE_FORUM_POST_title = "%(title)s";
export const SEO_TITLE_FORUM_POST_title_AT_PAGE_pagenum = "%(title)s  - str. %(pagenum)s";
export const TURN_NOTIFICATIONS_OFF = "Vypni";
export const TURN_NOTIFICATIONS_ON = "Zapni";
